const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function parsePreRegisterChallenge(data) {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    throw new Error("Resposta de verificação inválida");
  }

  const challengeId = String(data.challengeId || data.ChallengeId || "").trim();
  if (!UUID_PATTERN.test(challengeId)) {
    throw new Error("Resposta de verificação inválida");
  }

  return {
    challengeId,
    expiresAtUtc: data.expiresAtUtc || data.ExpiresAtUtc || null,
  };
}
